import v1seatTrade from './v1seatTrade'
import v1seatTradeFormReset from './v1seatTradeFormReset'
import v1seatTradeSearch from './v1seatTradeSearch'
import v1seatTradeTourOperators from './v1seatTradeTourOperators'

export default [
  v1seatTrade,
  v1seatTradeFormReset,
  v1seatTradeSearch,
  v1seatTradeTourOperators,
]
